const purchaseDeletedPage = require('./purchaseDeleted-page')
const purchaseDeletedDt = require('./purchaseDeleted-dt')
const purchaseDeletedFullcont = require('./purchaseDeleted-fullcont')

export function start(detail) {
  const component = components[detail.elem]
  if (component) component.start(detail)
}

const components = {
  page: { start: detail => purchaseDeletedPage.start(detail) },
  dt: { start: detail => purchaseDeletedDt.start(detail) },
  fullcont: { start: detail => purchaseDeletedFullcont.start(detail) }
}

